import { render, staticRenderFns } from "./singleadverts.vue?vue&type=template&id=4371d284"
import script from "./singleadverts.vue?vue&type=script&lang=js"
export * from "./singleadverts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports